import { render, staticRenderFns } from "./PostEditorBooks.vue?vue&type=template&id=7eae4b9e&scoped=true&"
import script from "./PostEditorBooks.vue?vue&type=script&lang=js&"
export * from "./PostEditorBooks.vue?vue&type=script&lang=js&"
import style0 from "./PostEditorBooks.vue?vue&type=style&index=0&id=7eae4b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eae4b9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
